import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreIdentityWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    {
      path: '/login',
      layout: 'blank',
      public: true,
      component: () => import('./pages/LoginPage.js'),
    },
    {
      path: '/pending',
      layout: 'blank',
      allowRestricted: true,
      component: () => import('./pages/PendingPage.js'),
    },
    { path: '/account', allowRestricted: true, component: () => import('./pages/AccountPage.js') },
    { path: '/admin/users', component: () => import('./pages/UsersPage.js') },
  ],
});
